import { newToolFilterOAuthMcp } from "../oauth.ts";

export const honeycombMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.honeycomb.io/favicon-32x32.png",
  url: "https://mcp.honeycomb.io/mcp",
  label: "Honeycomb",
});
